import types from '../../types/types';

const initialState = {};

const inscriptionReducer = ( state = initialState, action: any ) => {

    switch ( action.type ) {
        
        case types.saveInscriptionFormData:
            return {
                ...state,
                ...action.payload
            }

        case types.deleteInscriptionData:
            return {}

        default:
            return state;

    }

}

export default inscriptionReducer;

